var _style, _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascriptListasLacos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#031326}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e589ef",
    d: "M48.4 7.1l-46.8 17v18.6l46.8-17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f799ff",
    d: "M48.4 7H1.6v17.1l46.8-17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6 44.2H.4V5.8h49.3v38.4zM2.9 41.7h44.3V8.3H2.9v33.4z",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9.1c-.2 0-.4-.2-.4-.4V6.8c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .3-.2.4-.4.4zm0 4.9c-.2 0-.4-.2-.4-.4v-1.9c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .3-.2.4-.4.4zm0 5c-.2 0-.4-.2-.4-.4v-1.9c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .2-.2.4-.4.4zm0 4.9c-.2 0-.4-.2-.4-.4v-1.9c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .2-.2.4-.4.4zm0 4.9c-.2 0-.4-.2-.4-.4v-1.9c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .2-.2.4-.4.4zm0 4.9c-.2 0-.4-.2-.4-.4v-1.9c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .2-.2.4-.4.4zm0 4.9c-.2 0-.4-.2-.4-.4v-1.9c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .3-.2.4-.4.4zm0 4.9c-.2 0-.4-.2-.4-.4v-1.9c0-.2.2-.4.4-.4s.4.2.4.4v1.9c0 .3-.2.4-.4.4zM6.2 25.7c-.7 0-1.2-.6-1.2-1.2v-6.9c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v6.9c0 .6-.5 1.2-1.2 1.2zm37.7 13c-.7 0-1.2-.6-1.2-1.2v-6.9c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v6.9c.1.6-.5 1.2-1.2 1.2z",
    className: "st2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4,
    cy: 33,
    r: 1.7,
    className: "st2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptListasLacos);
export default __webpack_public_path__ + "static/media/javascript-listas-lacos.4e84aa2889f575f59b72a8069e5fefa7.svg";
export { ForwardRef as ReactComponent };